export const REG_FLOW_ROUTES = {
    personalInfo: '/register/personalInformation',
    testCenter: '/register/testCenter',
    testCenterSearch: '/register/testCenterSearch',
    waitList: '/register/waitList',
    photoUpload: '/register/photoUpload',
    purchase: '/register/purchase',
    paymentConfirmation: '/register/paymentConfirmation',
};

export const REGISTRATION_ROUTES = {
    landing: '/register',
    dashboard: '/register/incomplete',
    manageDashboard: '/register/manage',
    manageSchoolDayDashboard: '/register/manageSd',
    cancelConfirmation: '/register/cancelConfirmation',
    ...REG_FLOW_ROUTES,
};

export const EXTERNAL_ROUTES = {
    scoresends: import.meta.env.VITE_SCORE_SENDS,
    homepage: import.meta.env.VITE_MY_SAT_URL,
};

export const AUTH_ROUTES = {
    login: '/login',
    nonstudent: '/nonstudent',
};

const ROUTES = {
    ...AUTH_ROUTES,
    ...REGISTRATION_ROUTES,
    ...EXTERNAL_ROUTES,
};

interface Routes {
    [key: string]: string;
}

export default ROUTES as Routes;

export const ROUTE_TITLES = {
    [ROUTES.personalInfo]: 'SAT Registration - Personal Information',
    [ROUTES.testCenter]: 'SAT Registration - Test Center',
    [ROUTES.photoUpload]: 'SAT Registration - Photo Upload',
    [ROUTES.purchase]: 'SAT Registration - Purchase',
    [ROUTES.dashboard]: 'SAT Registration - Incomplete Registration Dashboard',
    [ROUTES.manageDashboard]: 'SAT Registration - Manage Registration Dashboard',
    [ROUTES.cancelConfirmation]: 'SAT Registration - Confirmation',
    [ROUTES.waitList]: 'SAT Registration - Wait List',
};
